<template>
  <div>
    <v-container fluid dense>
      <v-row justify="space-around">
        <v-col v-for="(item, index) in dashboard" :key="index">
          <component :is="item.componente" :item="item" :base="base" :apikey="apikey" :istanza="istanza"/>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  // import { verificaLicenza } from '@/mixins/verificaLicenza.js'
  import configurazioni from '@/services/configurazioniService'
  import SnippletTabella from './elementi/snippletTabella.vue'
  import Tabella from './elementi/tabella.vue'
  import Grafico from './elementi/grafico.vue'

  export default {
    name: 'Dashboard',
    components: {
      SnippletTabella,
      Tabella,
      Grafico
    },
    // mixins: [verificaLicenza],
    data: () => ({
/*       tipiRaggruppamento: ['Marchio', 'Categoria1', 'Categoria2'], // TODO: prendere da db
      tipiRaggruppamentoVariabili: ['marchio', 'statistici.categoria1.descrizione', 'varianti.variante1.descrizione', 'varianti.variante2.descrizione'], */
      dashboard: null,
      base: '',
      apikey: '',
      istanza: ''
    }),
    computed: {
      device() {
        return this.$store.getters['mobile/device']
      }
    },
    watch: {
      device(value) {
        this.dashboard = value.dashboard
        this.base = value.base
        this.istanza = value.istanza
        this.apikey = value.apiKey
      }
/*       setTimeout(async () => {
        await this.gestioneToken()
      }, 100) */
    },
    async mounted() {
      if (this.device) {
        this.base = this.device.base
        this.istanza = this.device.istanza
        this.apikey = this.device.apiKey
        const platform = await configurazioni.getConfigurazione(this.base, 'mobile', 'platform', this.istanza)
        if (platform) {
          this.dashboard = platform.dashboard
        }
      }
    },
    methods: {
    }
  }
</script>
